import { Monitor, Laptop, Keyboard, Mouse, Package } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import {
  useMyDevices,
  getDeviceTypeName,
  getDeviceStatusName,
  getDeviceStatusColor,
  type DeviceType,
} from '@/hooks'

const deviceIcons: Record<DeviceType, React.ComponentType<{ className?: string }>> = {
  computer: Laptop,
  monitor: Monitor,
  keyboard: Keyboard,
  mouse: Mouse,
  other: Package,
}

export function MyDevices() {
  const { data: devices, isLoading, error } = useMyDevices()

  if (isLoading) {
    return (
      <div className="rounded-lg border p-6">
        <h2 className="mb-4 text-lg font-semibold">我的设备</h2>
        <p className="text-muted-foreground">加载中...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-lg border p-6">
        <h2 className="mb-4 text-lg font-semibold">我的设备</h2>
        <p className="text-destructive">加载失败</p>
      </div>
    )
  }

  return (
    <div className="rounded-lg border p-6">
      <h2 className="mb-4 text-lg font-semibold">我的设备</h2>

      {!devices?.length ? (
        <p className="text-muted-foreground">暂无分配的设备</p>
      ) : (
        <div className="space-y-4">
          {devices.map((device) => {
            const Icon = deviceIcons[device.type]
            return (
              <div
                key={device.id}
                className="flex items-start gap-4 rounded-lg border p-4"
              >
                <div className="rounded-lg bg-muted p-2">
                  <Icon className="h-6 w-6" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-medium">{device.name}</h3>
                    <Badge className={getDeviceStatusColor(device.status)}>
                      {getDeviceStatusName(device.status)}
                    </Badge>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    {getDeviceTypeName(device.type)}
                    {device.brand && ` · ${device.brand}`}
                    {device.model && ` ${device.model}`}
                  </p>
                  <p className="text-sm text-muted-foreground">
                    序列号: {device.serialNumber}
                  </p>
                  {device.assignment?.assignedAt && (
                    <p className="text-sm text-muted-foreground">
                      分配时间: {new Date(device.assignment.assignedAt).toLocaleDateString('zh-CN')}
                    </p>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
